import type { MealEstimate } from "../../types";
import type { VisionProvider } from "../types";

export const mockProvider: VisionProvider = {
  name: "mock",
  enabled: true,
  async estimate({ caption }, options): Promise<MealEstimate> {
    options?.onProgress?.("uploading");
    await new Promise((r) => setTimeout(r, 200));
    options?.onProgress?.("analyzing");
    await new Promise((r) => setTimeout(r, 400));
    options?.onProgress?.("parsing");
    if (options?.signal?.aborted) throw new DOMException("Aborted", "AbortError");
    const hasChicken = (caption ?? "").toLowerCase().includes("chicken");
    const items = hasChicken
      ? [
          { name: "Grilled chicken breast", portion: "~150 g", calories: 245, protein_g: 46, carbs_g: 0, fat_g: 6 },
          { name: "Steamed rice", portion: "~1 cup", calories: 205, protein_g: 4, carbs_g: 45, fat_g: 0.5 },
          { name: "Mixed vegetables", portion: "~1 cup", calories: 75, protein_g: 3, carbs_g: 15, fat_g: 0.5, fiber_g: 5 }
        ]
      : [
          { name: "Sample meal", portion: "1 plate", calories: 520, protein_g: 28, carbs_g: 55, fat_g: 18, fiber_g: 6 }
        ];
    const totals = items.reduce(
      (a, i) => ({
        calories: a.calories + i.calories,
        protein_g: a.protein_g + i.protein_g,
        carbs_g: a.carbs_g + i.carbs_g,
        fat_g: a.fat_g + i.fat_g,
        fiber_g: a.fiber_g + (i.fiber_g ?? 0)
      }),
      { calories: 0, protein_g: 0, carbs_g: 0, fat_g: 0, fiber_g: 0 }
    );
    return {
      items,
      totals,
      confidence: "medium",
      clarifying_questions: caption ? [] : ["What's the approximate portion size?"],
      notes: "Mock provider — wire up real vision APIs in src/lib/vision/providers/."
    };
  }
};
